import { createAction } from '@ngrx/store';
export const setRegenerationReportOn = createAction('[Custom PDF Report Modal] Set Re-generation Report State On');
export const setRegenerationReportOff = createAction('[Custom PDF Report Modal] Set Re-generation Report State Off');
